import { Component } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { ContactSectionComponent } from '../../sections/contact-section/contact-section.component';
@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [HeaderComponent,ContactSectionComponent],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss'
})
export class ContactComponent {
  constructor() {
    document.body.style.backgroundColor = '#fff';
  }
  
}
